
import { Component, Prop, Vue } from "vue-property-decorator";
import { Routes } from "@/router";

@Component
export default class DossierDocumentsActions extends Vue {
  @Prop({ default: null }) dossierId!: string;

  navigateToRelatedDocuments(): void {
    this.$router.push({
      name: Routes.RelatedDocuments,
      params: {
        dossierId: this.dossierId,
      },
    });
  }
}
